export default [
    /**
     * CONFIGURACION DE TRANSACCIONES
     */
    {
        path: '/contabilidad/transacciones/transacciones-contables',
        name: 'contabilidad-transacciones-transacciones-contables',
        component: () => import('@/views/pages/contabilidad/TransaccionContable.vue'),
        meta: {
            title: 'i18n:contabilidad.transacciones.transaccion_contable.menu_title',
            resource: 'contabilidad',
            action: 'ver-contabilidad-transacciones-transacciones-contables',
            breadcrumb: [
                {
                    text: 'contabilidad.menu_title',
                    active: true,
                },
                {
                    text: 'global.menu.transacciones',
                    active: true,
                },
                {
                    text: 'contabilidad.transacciones.transaccion_contable.menu_title',
                },
            ],
        },
    },
    /**
     * CONFIGURACION DE MANTENIMIENTOS
     */
    {
        title: 'i18n:',
        path: '/contabilidad/mantenimiento/proceso',
        name: 'contabilidad-mantenimiento-proceso',
        component: () => import('@/views/pages/contabilidad/mantenimiento/Proceso.vue'),
        meta: {
            title: 'i18n:Proceso',
            resource: 'Contabilidad',
            action: 'ver-contabilidad-mantenimiento-proceso',
            breadcrumb: [
                {
                    text: 'Proceso',
                    active: true,
                },
            ],
        },
    },

    /**
     * CONFIGURACION DE INFORMES
     */

    {
        title: 'i18n:',
        path: '/contabilidad/informes/cronometro-provisiones',
        name: 'contabilidad-informes-cronometro-provisiones',
        component: () => import('@/views/pages/contabilidad/informes/CronometroProvision.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.cronometro-provisiones.menu_title',
            resource: 'contabilidad',
            action: 'ver-contabilidad-informes-cronometro-provisiones',
            breadcrumb: [
                {
                    text: 'contabilidad.menu_title',
                    active: true,
                },
                {
                    text: 'global.menu.informes',
                    active: true,
                },
                {
                    text: 'contabilidad.informes.cronometro-provisiones.menu_title',
                },
            ],
        },
    },
    {
        title: 'i18n:',
        path: '/contabilidad/informes/reporte-plan-cuenta',
        name: 'contabilidad-informes-reporte-plan-cuenta',
        component: () => import('@/views/pages/contabilidad/informes/ReportePlanCuenta.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.plan_cuenta_niif.menu_title',
            resource: 'Contabilidad',
            action: 'ver-contabilidad-informes-reporte-plan-cuenta',
            breadcrumb: [
                { text: 'Contabilidad' },
                { text: 'Informes' },
                { text: 'contabilidad.informes.plan_cuenta.menu_title' },
            ],
        },
    },
    {
        title: 'i18n:',
        path: '/contabilidad/mantenimiento/codigo-transaccion',
        name: 'contabilidad-mantenimiento-codigo-transaccion',
        component: () => import('@/views/pages/contabilidad/mantenimiento/CodigoTransaccion.vue'),
        meta: {
            title: 'Codigo Transacción',
            resource: 'contabilidad',
            action: 'ver-contabilidad-mantenimiento-codigo-transaccion',
            breadcrumb: [
                {
                    text: 'Codigo Transacción',
                    active: true,
                },
            ],
        },
    },
    {
        title: 'i18n:',
        path: '/contabilidad/informe/desempeno-contable',
        name: 'contabilidad-informe-reporte-desempeno-contable',
        component: () => import('@/views/pages/contabilidad/informes/DesempenoContable.vue'),
        meta: {
            title: 'i18n:Desempeño Contable',
            resource: 'Contabilidad',
            action: 'ver-contabilidad-informe-reporte-desempeno-contable',
            breadcrumb: [{ text: 'Contabilidad' }, { text: 'Informes' }, { text: 'Desempeño Contable' }],
        },
    },
]
